<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2" style="gap: 10px">
              <div class="search-box" style="min-width: 200px; flex: 1; max-width: 280px">
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search"
                    placeholder="Buscar formulários..."
                    @keyup.enter="doSearch"
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
              <div class="d-flex flex-wrap" style="gap: 8px">
                <button type="button" class="btn btn-primary btn-rounded" @click="openGroups()">
                  Grupos
                </button>
                <button type="button" class="btn btn-info btn-rounded" @click="openThankYouPages()">
                  <i class="mdi mdi-check-circle mr-1"></i> Pag. Obrigado
                </button>
                <button type="button" class="btn btn-warning btn-rounded" @click="showWidgetModal = true">
                  <i class="bx bx-code-alt mr-1"></i> Widget
                </button>
                <button type="button" class="btn btn-success btn-rounded" @click="newForm()">
                  <i class="mdi mdi-plus mr-1"></i> Novo Formulário
                </button>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th width="30%">Nome</th>
                    <th width="15%">Tipo</th>
                    <th width="8%">Campos</th>
                    <th width="8%">Steps</th>
                    <th width="12%">Com acompanhante</th>
                    <th width="10%">Status</th>
                    <th width="12%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="form in formsList" :key="form.id">
                    <td class="link" @click="editForm(form.id)">
                      <h5 class="font-size-14 mb-1">
                        <span class="text-dark">{{ form.name }}</span>
                      </h5>
                      <p class="text-muted mb-0" v-if="form.description">
                        {{ form.description | truncate(50) }}
                      </p>
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="form.type === 'action' ? 'badge-soft-warning' : 'badge-soft-primary'"
                      >
                        <i class="bx" :class="form.type === 'action' ? 'bx-bolt-circle' : 'bx-user'"></i>
                        {{ form.type === 'action' ? 'Ação' : 'Inscrição' }}
                      </span>
                    </td>
                    <td>
                      <span class="badge badge-soft-info font-size-12">
                        {{ form.fields_count || 0 }}
                      </span>
                    </td>
                    <td>
                      <span class="badge badge-soft-secondary font-size-12">
                        {{ form.steps_count || 0 }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="(form.companion_config && form.companion_config.enabled) ? 'badge-soft-info' : 'badge-soft-secondary'"
                      >
                        {{ (form.companion_config && form.companion_config.enabled) ? 'Sim' : 'Não' }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="form.status ? 'badge-soft-success' : 'badge-soft-danger'"
                        style="cursor: pointer"
                        @click="toggleStatus(form.id)"
                      >
                        {{ form.status ? 'Ativo' : 'Inativo' }}
                      </span>
                    </td>
                    <td>
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          @click="editForm(form.id)"
                          title="Editar"
                        >
                          <i class="bx bx-edit-alt"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-info"
                          @click="duplicateForm(form)"
                          title="Duplicar"
                        >
                          <i class="bx bx-copy"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          @click="deleteForm(form)"
                          title="Excluir"
                        >
                          <i class="bx bx-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="formsList.length === 0">
                    <td colspan="7" class="text-center py-4">
                      <p class="text-muted mb-0">Nenhum formulário encontrado</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      @input="updateList"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalGroup" ref="formGroup"></modal-form>

    <!-- Modal: Tipo de Formulário -->
    <b-modal v-model="showTypeModal" hide-header hide-footer centered content-class="type-modal-content">
      <div class="type-modal-header">
        <h5 class="mb-1">Criar novo formulário</h5>
        <p class="text-muted mb-0">Qual tipo de formulário você precisa?</p>
      </div>
      <div class="type-modal-options">
        <div
          class="type-option"
          :class="{ 'selected': hoveredType === 'registration' }"
          @click="createFormWithType('registration')"
          @mouseenter="hoveredType = 'registration'"
          @mouseleave="hoveredType = null"
        >
          <div class="type-option-icon bg-soft-primary">
            <i class="bx bx-user-plus text-primary"></i>
          </div>
          <div class="type-option-info">
            <h6 class="mb-1">Formulário de Inscrição</h6>
            <p class="text-muted mb-0">Inclui campos padrão como nome, e-mail e telefone. Ideal para captar novos participantes.</p>
          </div>
          <div class="type-option-arrow">
            <i class="bx bx-chevron-right"></i>
          </div>
        </div>
        <div
          class="type-option"
          :class="{ 'selected': hoveredType === 'action' }"
          @click="createFormWithType('action')"
          @mouseenter="hoveredType = 'action'"
          @mouseleave="hoveredType = null"
        >
          <div class="type-option-icon bg-soft-success">
            <i class="bx bx-task text-success"></i>
          </div>
          <div class="type-option-info">
            <h6 class="mb-1">Formulário de Ação</h6>
            <p class="text-muted mb-0">Para ações de retorno, onde o participante volta para enviar dados adicionais. Ex: anexar aéreo, aceitar termos, enviar documentos pós inscrição.</p>
          </div>
          <div class="type-option-arrow">
            <i class="bx bx-chevron-right"></i>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Widget / Embed Modal -->
    <b-modal v-model="showWidgetModal" title="Widget / Embed" size="lg" hide-footer centered>
      <div class="mb-4">
        <label class="font-weight-bold mb-2 d-block">Código de incorporação</label>
        <div class="embed-code-block position-relative">
          <pre class="bg-dark text-light p-3 rounded mb-0"><code>{{ widgetEmbedCode }}</code></pre>
          <button
            class="btn btn-sm btn-light position-absolute copy-btn"
            @click="copyEmbedCode"
          >
            <i class="bx" :class="widgetCopied ? 'bx-check text-success' : 'bx-copy'"></i>
            {{ widgetCopied ? 'Copiado!' : 'Copiar Código' }}
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label class="font-weight-bold mb-2 d-block">Como usar</label>
        <ol class="text-muted mb-0 pl-3">
          <li class="mb-1">Copie o código acima</li>
          <li class="mb-1">Cole no HTML da sua landing page onde deseja exibir o formulário</li>
          <li>O formulário será carregado automaticamente com os campos configurados no Form Builder</li>
        </ol>
      </div>

      <div class="alert alert-info mb-0">
        <i class="bx bx-info-circle mr-1"></i>
        Alterações feitas no Form Builder refletem automaticamente no widget. O formulário precisa estar com status <strong>Ativo</strong> para ser exibido.
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import ModalForm from '../groups/Form'

export default {
  components: {
    Layout,
    PageHeader,
    ModalForm
  },
  name: 'FormBuilderIndex',
  page: {
    title: 'Form Builder',
    meta: [
      {
        name: 'description',
        content: appConfig.description
      }
    ]
  },
  data () {
    return {
      loading: true,
      search: '',
      params: {},
      currentPage: 1,
      perPage: 20,
      modalGroup: false,
      showTypeModal: false,
      hoveredType: null,
      showWidgetModal: false,
      widgetCopied: false,
      title: 'Form Builder',
      items: [
        {
          text: 'Form Builder'
        },
        {
          text: 'Listagem',
          active: true
        }
      ]
    }
  },
  filters: {
    truncate (value, length) {
      if (!value) return ''
      if (value.length <= length) return value
      return value.substring(0, length) + '...'
    }
  },
  mounted () {
    this.updateList()
  },
  computed: {
    ...mapState('formBuilder', ['forms']),
    widgetEmbedCode () {
      const apiUrl = window.location.origin
      return '<!-- Widget Eventfy -->\n<script src="https://cdn.eventfy.com.br/widget/dist/eventfy-widget.js"><' + '/script>\n<eventfy-widget api-url="' + apiUrl + '"></eventfy-widget>'
    },
    formsList () {
      return this.forms.data || []
    },
    rows () {
      return (this.forms.meta && this.forms.meta.total) || 0
    }
  },
  methods: {
    ...mapActions('formBuilder', {
      getForms: 'GetForms',
      deleteFormAction: 'DeleteForm',
      changeStatusAction: 'ChangeStatus',
      duplicateFormAction: 'DuplicateForm'
    }),
    copyEmbedCode () {
      navigator.clipboard.writeText(this.widgetEmbedCode).then(() => {
        this.widgetCopied = true
        setTimeout(() => {
          this.widgetCopied = false
        }, 2000)
      })
    },
    openGroups () {
      this.$refs.formGroup.open('')
      this.modalGroup = true
    },
    openThankYouPages () {
      this.$router.push({ name: 'form-builder-thank-you-pages' })
    },
    newForm () {
      this.showTypeModal = true
    },
    createFormWithType (type) {
      this.showTypeModal = false
      this.$router.push({ name: 'form-builder-new', query: { type } })
    },
    editForm (id) {
      this.$router.push({
        name: 'form-builder-edit',
        params: { id }
      })
    },
    async toggleStatus (id) {
      try {
        await this.changeStatusAction(id)
        successMessage('Status atualizado com sucesso.', 2500)
        this.updateList()
      } catch (err) {
        console.error(err)
        errorMessage('Erro ao atualizar status: ' + (err.response?.data?.message || err.message))
      }
    },
    async duplicateForm (form) {
      Swal.fire({
        title: 'Duplicar formulário?',
        html: `Será criada uma cópia de: <b>${form.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, duplicar!'
      }).then(async (result) => {
        if (result.value) {
          try {
            const loader = this.$loading.show()
            await this.duplicateFormAction(form.id)
            loader.hide()
            successMessage('Formulário duplicado com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            console.error(err)
            errorMessage('Erro ao duplicar: ' + (err.response?.data?.message || err.message))
          }
        }
      })
    },
    deleteForm (form) {
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será excluído o formulário: <b>${form.name}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, excluir!'
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.deleteFormAction(form.id)
            successMessage('Formulário excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            console.error(err)
            errorMessage('Erro ao excluir: ' + (err.response?.data?.message || err.message))
          }
        }
      })
    },
    doSearch () {
      this.currentPage = 1
      this.updateList()
    },
    updateList () {
      const params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      const loader = this.$loading.show()
      this.getForms(params)
        .then(() => {
          loader.hide()
        })
        .catch((error) => {
          console.error(error)
          loader.hide()
        })
    }
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
.table-responsive {
  min-height: 300px;
}
.float-sm-end {
  float: right;
}
.btn-group .btn {
  margin-right: 2px;
}
.embed-code-block {
  position: relative;
}
.embed-code-block pre {
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-all;
}
.copy-btn {
  top: 8px;
  right: 8px;
}
.type-modal-header {
  text-align: center;
  padding: 8px 0 20px;
}
.type-modal-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 8px;
}
.type-option {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.type-option:hover,
.type-option.selected {
  border-color: #556ee6;
  background: #f8f9ff;
  box-shadow: 0 4px 12px rgba(85, 110, 230, 0.12);
}
.type-option-icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
}
.type-option-info {
  flex: 1;
  min-width: 0;
}
.type-option-info h6 {
  font-weight: 600;
  font-size: 14px;
}
.type-option-info p {
  font-size: 12.5px;
  line-height: 1.4;
}
.type-option-arrow {
  flex-shrink: 0;
  font-size: 1.3rem;
  color: #adb5bd;
  transition: all 0.2s;
}
.type-option:hover .type-option-arrow {
  color: #556ee6;
  transform: translateX(3px);
}
</style>
